import { useId } from "react";
import { FACES, PENCIL_FACES, PALETTES, safeId } from "./mascotMood";
import { Face, BackEffects, FrontEffects, TypingDots } from "./faceParts";
import "./mascot.css";

export const PENCIL_VIEWBOX = "20 -34 160 262";
export const PENCIL_VIEW_W = 160;
export const PENCIL_VIEW_H = 262;
const BODY = "M70 50 H130 V176 L100 214 L70 176 Z";

// The game's host: peeks over the round timer, picks letters, reviews answers.
// mood accepts PENCIL_FACES keys (idle, thinking, judging…) and every timer mood in FACES.
export default function PencilMascot({ mood = "idle", face: faceOverride, color = "red", size = 72, shadow = true, label = "Namey", className = "" }) {
  const uid = safeId(useId());
  const face = faceOverride || PENCIL_FACES[mood] || FACES[mood] || PENCIL_FACES.idle;
  const pal = PALETTES[color] || PALETTES.red;
  const pale = face.fx?.includes("pale");

  return (
    <svg
      viewBox={PENCIL_VIEWBOX}
      width={size}
      height={(size * PENCIL_VIEW_H) / PENCIL_VIEW_W}
      className={`nm-mascot ${className}`}
      role={label ? "img" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
    >
      <defs>
        <linearGradient id={`${uid}g`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor={pal.top} />
          <stop offset="1" stopColor={pal.bot} />
        </linearGradient>
        <linearGradient id={`${uid}p`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#4c1d95" stopOpacity=".5" />
          <stop offset=".6" stopColor="#4c1d95" stopOpacity="0" />
        </linearGradient>
      </defs>
      {shadow && <ellipse cx="100" cy="220" rx="34" ry="5" fill="rgba(120,20,30,.14)" />}
      <g transform="translate(100 110) scale(.75) translate(-100 -110)">
        <BackEffects face={face} />
      </g>
      <g className={`nm-a nm-a-${face.a || "none"}`}>
        <g className={`nm-b nm-b-${face.b || "none"}`}>
          <path d="M70 176 L100 214 L130 176 Z" fill="#f5d0a9" />
          <path d="M91 202 L100 214 L109 202 Z" fill="#374151" />
          <rect x="70" y="50" width="60" height="128" fill={`url(#${uid}g)`} />
          <rect x="70" y="50" width="16" height="128" fill={pal.lip} opacity=".35" />
          <rect x="94" y="50" width="12" height="128" fill="#fff" opacity=".14" />
          {pale && <path d={BODY} fill={`url(#${uid}p)`} />}
          <rect x="67" y="30" width="66" height="24" rx="3" fill="#d1d5db" />
          <path d="M67 37 H133 M67 44 H133" stroke="#9ca3af" strokeWidth="2.5" />
          <rect x="70" y="6" width="60" height="28" rx="11" fill="#fda4af" />
          <rect x="74" y="10" width="14" height="18" rx="6" fill="#fff" opacity=".35" />
          <Face face={face} transform="translate(100 90) scale(.7) translate(-100 -72)" />
          <g transform="translate(100 90) scale(.7) translate(-100 -90)">
            <FrontEffects face={face} />
          </g>
        </g>
      </g>
      {face.dots && (
        <g transform="translate(110 -30)">
          <TypingDots />
        </g>
      )}
    </svg>
  );
}
